import React, { useState } from "react";
import { Table, Input, InputNumber, Form, Button, message, Typography, Popconfirm, Space, Row, Col } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
const { Title } = Typography;

const ExpensesTab = () => {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [expenses, setExpenses] = useState([
    { key: 1, item: "Fuel", amount: 1200 },
    { key: 2, item: "Lunch", amount: 800 },
  ]);

  const isEditing = (record) => record.key === editingKey;

  const addExpense = () => {
    const newKey = expenses.length ? expenses[expenses.length - 1].key + 1 : 1;
    const newExpense = { key: newKey, item: "", amount: 0 };
    setExpenses([...expenses, newExpense]);
    edit(newExpense);
  };

  const deleteExpense = (key) => {
    setExpenses(expenses.filter((expense) => expense.key !== key));
    message.success("Expense deleted!");
  };
  const edit = (record) => {
    form.setFieldsValue({ item: "", amount: "", ...record });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...expenses];
      const index = newData.findIndex((item) => item.key === key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setExpenses(newData);
        setEditingKey("");
        message.success("Expense updated!");
      }
    } catch (err) {
      console.log("Validation Failed:", err);
    }
  };

  const columns = [
    {
      title: "Item",
      dataIndex: "item",
      editable: true,
    },
    {
      title: "Amount (₹)",
      dataIndex: "amount",
      editable: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Space>
            <Button type="link" onClick={() => save(record.key)}>
              Save
            </Button>
            <Button type="link" onClick={cancel}>
              Cancel
            </Button>
          </Space>
        ) : (
          <Space>
            <Button type="link" disabled={editingKey !== ""} onClick={() => edit(record)}>
              Edit
            </Button>
            <Popconfirm
              title="Are you sure to delete this expense?"
              onConfirm={() => deleteExpense(record.key)}
              okText="Yes"
              cancelText="No"
            >
              <Button type="link" icon={<DeleteOutlined />} danger />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) return col;

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "amount" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = inputType === "number" ? <InputNumber /> : <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[{ required: true, message: `Please Input ${title}!` }]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  return (
    <>
    <Row justify="space-between" align="middle" gutter={[16, 16]} style={{ marginBottom: 16 }}>
      <Col xs={24} sm={12}>
        <Title level={5}>Trip Expenses</Title>
      </Col>
      <Col xs={24} sm={12} style={{ textAlign: "right" }}>
        <Button
          onClick={addExpense}
          type="primary"
          icon={<PlusOutlined />}
          disabled={editingKey !== ""}
        >
          Add Expense
        </Button>
      </Col>
    </Row>

    <Form form={form} component={false}>
      <Table
        components={{ body: { cell: EditableCell } }}
        bordered
        dataSource={expenses}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={false}
        scroll={{ x: "100%" }} // Makes table scrollable horizontally if needed
      />
    </Form>
  </>
    
  );
};

export default ExpensesTab;
